<!-- Residential Customer Type Layout -->
@if (!customer.customerTypeId || customer.customerTypeId == customerTypesEnum.Residential) {
<div class="container" [@enterAnimation]>
  <div class="row">
    <div class="col-12">
      @if (!smallerHeaders) {
      <h4>Contact Info</h4>
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Type</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Type</div>
      }
      @if (customer) {
      <ng-select class="custom" required bindValue="id" [searchable]="false" [items]="customerTypes"
        placeholder="Select a Type" [selectOnTab]="true" name="type" bindLabel="name"
        [(ngModel)]="customer.customerTypeId" [disabled]="!canEdit" (ngModelChange)="typeChange()">
      </ng-select>
      }
    </div>
    <span class="col-md-offset-6"><!-- Spacer to ensure layout is good --></span>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>First Name</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">First Name</div>
      }
      @if (customer?.customerContacts[0]) {
      <input pInputText fluid [disabled]="!canEdit" name="firstName"
        [(ngModel)]="customer.customerContacts[primaryContactIndex].firstName" #firstName required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Last Name</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Last Name</div>
      }
      @if (customer?.customerContacts[0]) {
      <input pInputText fluid [disabled]="!canEdit" name="lastName"
        [(ngModel)]="customer.customerContacts[primaryContactIndex].lastName" required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Email</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Email</div>
      }
      @if (customer?.customerContacts[0]) {
      <input pInputText fluid [disabled]="!canEdit" name="emailAddress"
        (blur)="emailChanged(customer.customerContacts[primaryContactIndex].emailAddress)"
        [(ngModel)]="customer.customerContacts[primaryContactIndex].emailAddress.email" required email />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Telephone Number</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Telephone Number</div>
      }
      @if (customer?.customerContacts[0]) {
      <input pInputText fluid mask="(000) 000-0000" placeholder="(     )      -" [disabled]="!canEdit"
        [style]="{'width': '100%'}" name="phoneNumber"
        [(ngModel)]="customer.customerContacts[primaryContactIndex].phoneNumber" (ngModelChange)="onPhoneChange()" />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Text Notifications</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Text Notifications</div>
      }
      @if (customer) {
      <ng-select class="custom" [disabled]="!canEdit || isPhoneNumberEmpty()" [required]="!isPhoneNumberEmpty()"
        [items]="textingOptions" name="textoption" [selectOnTab]="true" bindValue="value" [clearable]="false"
        [(ngModel)]="customer.customerContacts[primaryContactIndex].textingOptOut">
      </ng-select>
      }
    </div>
    <div class="col-12 top-padding">
      @if (!smallerHeaders) {
      <h4>Address</h4>
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Billing Address Line 1</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Billing Address Line 1</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="street" [(ngModel)]="customer.address.street" required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Billing Address Line 2</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Billing Address Line 2</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="apt" [(ngModel)]="customer.address.apartment" />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>City</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">City</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="city" [(ngModel)]="customer.address.city" required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>State</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">State</div>
      }
      @if (customer) {
      <ng-select class="custom" [disabled]="!canEdit" required [items]="states" placeholder="Select a State"
        [selectOnTab]="true" (ngModelChange)="onStateSelect($event)" name="state" bindLabel="name"
        [(ngModel)]="selectedState">
      </ng-select>
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Zip</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Zip</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="zip" [(ngModel)]="customer.address.zip" maxlength="5"
        required />
      }
    </div>
    <span class="col-md-offset-6"><!-- Spacer to ensure layout is good --></span>
    @if (!isCustomer) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Active</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Active</div>
      }
      @if (customer) {
      <p-checkbox binary="true" [disabled]="!canEdit" name="active" [(ngModel)]="customer.active">
      </p-checkbox>
      }
    </div>
    }
    @if (!isCustomer) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Tax Exempt</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Tax Exempt</div>
      }
      @if (customer) {
      <p-checkbox binary="true" name="taxExempt" [(ngModel)]="customer.taxExempt"
        [disabled]="!canEdit || isCustomer"></p-checkbox>
      }
    </div>
    }
    @if (!isCustomer) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Payment Info Required</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Payment Info Required</div>
      }
      @if (customer) {
      <p-checkbox binary="true" name="paymentInfoRequired" [(ngModel)]="customer.paymentInfoRequired"
        [disabled]="!canEdit || isCustomer || !canEditBilling" (click)="paymentInfoRequiredChange()"></p-checkbox>
      }
    </div>
    }
  </div>
</div>
}
<!-- Non-Residential Customer Type Layout -->
@if (customer.customerTypeId && customer.customerTypeId != customerTypesEnum.Residential) {
<div [@enterAnimation]>
  <div class="row">
    <div class="col-12">
      @if (!smallerHeaders) {
      <h4>Contact Info</h4>
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Type</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Type</div>
      }
      @if (customer) {
      <ng-select class="custom" required bindValue="id" [searchable]="false" [items]="customerTypes"
        placeholder="Select a Type" [selectOnTab]="true" name="type" bindLabel="name"
        [(ngModel)]="customer.customerTypeId" [disabled]="!canEdit" (ngModelChange)="typeChange()">
      </ng-select>
      }
    </div>
    <div class="col-12">
      @if (!smallerHeaders) {
      <h6>Company Name</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Company Name</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="companyName" [(ngModel)]="customer.companyName" #companyName
        required />
      }
    </div>
    @if (!isCustomer) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Active</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Active</div>
      }
      @if (customer) {
      <p-checkbox binary="true" [disabled]="!canEdit" name="active" [(ngModel)]="customer.active">
      </p-checkbox>
      }
    </div>
    }
    @if (token) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Tax Exempt</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Tax Exempt</div>
      }
      @if (customer) {
      <p-checkbox binary="true" name="taxExempt" [(ngModel)]="customer.taxExempt"
        [disabled]="!canEdit || isCustomer"></p-checkbox>
      }
    </div>
    }
    @if (!token) {
    <div class="col-4">
    </div>
    }
    @if (isCustomer) {
    <div class="col-4">
    </div>
    }
    @if (!isCustomer) {
    <div class="col-4">
      @if (!smallerHeaders) {
      <h6>Payment Info Required</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Payment Info Required</div>
      }
      @if (customer) {
      <p-checkbox binary="true" name="paymentInfoRequired" [(ngModel)]="customer.paymentInfoRequired"
        [disabled]="!canEdit || isCustomer || !canEditBilling" (onChange)="paymentInfoRequiredChange()"></p-checkbox>
      }
    </div>
    }
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Billing Address</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Billing Address</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="street" [(ngModel)]="customer.address.street" required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>City</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">City</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="city" [(ngModel)]="customer.address.city" required />
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>State</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">State</div>
      }
      @if (customer) {
      <ng-select class="custom" [disabled]="!canEdit" required [items]="states" placeholder="Select a State"
        [selectOnTab]="true" (ngModelChange)="onStateSelect($event)" name="state" bindLabel="name"
        [(ngModel)]="selectedState">
      </ng-select>
      }
    </div>
    <div class="col-6">
      @if (!smallerHeaders) {
      <h6>Zip</h6>
      }
      @if (smallerHeaders) {
      <div class="rfq-header">Zip</div>
      }
      @if (customer) {
      <input pInputText fluid [disabled]="!canEdit" name="zip" [(ngModel)]="customer.address.zip" maxlength="5"
        required />
      }
    </div>
  </div>
</div>
}
<div class="row">
  @if (customer?.createdDate) {
  <div class="col-6">
    @if (!smallerHeaders) {
    <h6>Created</h6>
    }
    @if (smallerHeaders) {
    <div class="rfq-header">Created</div>
    }
    {{customer.createdDate | date: 'shortDate'}}
  </div>
  }
</div>
<div>
  @if (customer.customerTypeId && customer.customerTypeId != customerTypesEnum.Residential) {
  <div [@enterAnimation]>
    <div class="row columnPadding" style="padding-bottom:0px;">
      <div class="col-12">
        @if (!smallerHeaders) {
        <h6>Main Contact</h6>
        }
        @if (smallerHeaders) {
        <div class="rfq-header">Main Contact</div>
        }
      </div>
    </div>
    <app-customer-contact [customerContact]="customer.customerContacts[primaryContactIndex]" [canEdit]="canEdit"
      [customerTypeId]="customer.customerTypeId" (deleted)="deleteContact($event)" [smallerHeaders]="smallerHeaders">
    </app-customer-contact>
  </div>
  }
  @if (customer.customerContacts.length > 1) {
  <div class="container">
    <div class="row columnPadding" style="padding-bottom:0px;">
      <div class="col-12">
        @if (!smallerHeaders) {
        <h6>Additional Contact(s)</h6>
        }
        @if (smallerHeaders) {
        <div class="rfq-header">Additional Contact(s)</div>
        }
      </div>
    </div>
    @for (contact of customer.customerContacts; track contact; let i = $index) {
    <div>
      @if (i != primaryContactIndex) {
      <div class="contact-container">
        @if (customer.customerContacts[i].active) {
        <app-customer-contact [customerContact]="customer.customerContacts[i]" [canEdit]="canEdit"
          [customerTypeId]="customer.customerTypeId" [smallerHeaders]="smallerHeaders"
          (deleted)="deleteContact($event)">
        </app-customer-contact>
        }
      </div>
      }
    </div>
    }
  </div>
  }
  <div class="container">
    <div class="row">
      <div class="col-12" style="padding-top: 15px;">
        @if (!isCustomer && !hideAddContact) {
        <p-button type="button" severity="success" [disabled]="!canEdit" label="Add Contact"
          (click)="addContact(false)"></p-button>
        }
      </div>
    </div>
  </div>
</div>